module.exports = __webpack_public_path__ + "static/hire_remote_team_mobile@2x-df6961b14afaeb59f5de9907dfbda00c.png";